import { lazy } from "react";

const ResetPassword = lazy(() => import("@/pages/Authentication/ResetPassword"));
const LockScreen = lazy(() => import("@/pages/Authentication/LockScreen"));
const ExpiredToken = lazy(() => import("@/pages/Authentication/ExpiredToken"));
const Logout = lazy(() => import("@/pages/Authentication/Logout"));
const ForgetPassword = lazy(() => import("@/pages/Authentication/ForgetPassword"));

const Alt404 = lazy(() => import("@/pages/Others/Alt404"));
const Basic404 = lazy(() => import("@/pages/Others/Basic404"));
const Error500 = lazy(() => import("@/pages/Others/Error500"));
const Offlinepage = lazy(() => import("@/pages/Others/Offlinepage"));
const ComingSoon = lazy(() => import("@/pages/Others/ComingSoon"));
const Maintenance = lazy(() => import("@/pages/Others/Maintenance"));
const NotFound = lazy(() => import("@/pages/Others/NotFound"));

const Register  = lazy(() => import("@/pages/Authentication/Register"));

const AuthPage_GLOBO   = lazy(() => import("@/pages/Authentication/AuthPage_GLOBO"));

export var authPublicRoutes = [
    { path: "/logout", component: <Logout /> },
    { path: "/login", component: <AuthPage_GLOBO /> },
    { path: "/register", component: <Register /> },
    { path: "/forgot-password", component: <ForgetPassword /> },
    { path: "/lockscreen", component: <LockScreen /> },
    { path: "/reset-password", component: <ResetPassword /> },
    { path: "/expired-token", component: <ExpiredToken /> },
    { path: "/auth-404-basic", component: <Basic404 /> },
    { path: "/auth-404-alt", component: <Alt404 /> },
    { path: "/auth-500", component: <Error500 /> },
    { path: "/auth-offline", component: <Offlinepage /> },
    { path: "/not-found", component: <NotFound /> },
    { path: "/under-maintenance", component: <Maintenance /> },
    { path: "/coming-soon", component: <ComingSoon /> },
];